/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Lightbox from "react-awesome-lightbox";
import PDFExport from "../../../helper/export-pdf";
import { optionsFactory } from "../../../helper/table";
import paginationFactory from "react-bootstrap-table2-paginator";

import { sortCaret } from "../../../../_metronic/_helpers";
import "react-awesome-lightbox/build/style.css";
import {
  Card,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

export default function Results(props) {
  const [isOpen, setImage] = useState(false);
  const _rows = props.rows.sort((a, b) => a.no - b.no);
  function ViewPhoto(r, row, l) {
    if (row?.file === "NO") {
      return null;
    }
    return (
      <>
        <img
          alt="product"
          className="image-fluid rounded cursor-pointer"
          height="60px"
          onClick={() => setImage(row.image)}
          width="60px"
          src={row.image}
        />
      </>
    );
  }

  const pos_map = _rows.map((key) => key.pos);
  const pos_unique = [...new Set(pos_map)];
  const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
  const [pos_selected, pos_setSelected] = useState([]);

  const round_map = _rows.map((key) => key.round);
  const round_unique = [...new Set(round_map)];
  const round_options = round_unique.map((key) => ({ label: key, value: key }));
  const [round_selected, round_setSelected] = useState([]);

  const product_map = _rows.map((key) => key.product);
  const product_unique = [...new Set(product_map)];
  const product_options = product_unique.map((key) => ({
    label: key,
    value: key,
  }));
  const [product_selected, product_setSelected] = useState([]);

  const agent_map = _rows.map((key) => key.agent);
  const agent_unique = [...new Set(agent_map)];
  const agent_options = agent_unique.map((key) => ({ label: key, value: key }));
  const [agent_selected, agent_setSelected] = useState([]);

  const task_map = _rows.map((key) => key.task);
  const task_unique = [...new Set(task_map)];
  const task_options = task_unique.map((key) => ({ label: key, value: key }));
  const [task_selected, task_setSelected] = useState([]);
  const [task_types, tasktypes_setSelected] = useState([]);



  useEffect(() => {
    const pos_map = _rows.map((key) => key.pos);
    const pos_unique = [...new Set(pos_map)];
    const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
    pos_setSelected(pos_options);
    const round_map = _rows.map((key) => key.round);
    const round_unique = [...new Set(round_map)];
    const round_options = round_unique.map((key) => ({
      label: key,
      value: key,
    }));
    round_setSelected(round_options);
    const product_map = _rows.map((key) => key.product);
    const product_unique = [...new Set(product_map)];
    const product_options = product_unique.map((key) => ({
      label: key,
      value: key,
    }));
    product_setSelected(product_options);
    const agent_map = _rows.map((key) => key.agent);
    const agent_unique = [...new Set(agent_map)];
    const agent_options = agent_unique.map((key) => ({
      label: key,
      value: key,
    }));
    agent_setSelected(agent_options);
    const task_map = props.tasks.map((key) => key.name);
    const tasks_types = [
      ...new Set(props.tasks.map((key) => key.input_type).flat()),
    ].reduce((hs, tp) => ({ ...hs, [tp]: true }), {});
    tasktypes_setSelected(tasks_types);
    const task_unique = [...new Set(task_map)];
    const task_options = task_unique.map((key) => ({ label: key, value: key }));
    task_setSelected(task_options);
  }, [_rows, props.tasks]);
  const _columns = {
    pos: "POS",
    round: "Round",
    product: "Product",
    agent: "Employee",
    task: "Task",
  };
  if (task_types["File (photo)"]) {
    _columns.file = "Photo";
  }
  if (task_types["Rate"]) {
    _columns.rate = "Rate";
  }
  if (task_types["Comment"]) {
    _columns.comment = "Comment";
  }
  if (task_types["Yes/No"]) {
    _columns.yesno = "Yes/No";
  }

  if (task_types["Quantity"]) {
    _columns.quantity = "Quantity";
  }

  const cols = Object.entries(_columns).map(([field, name]) => {
    if (field === "file") {
      return {
        dataField: field,
        text: name,
        sort: true,
        sortCaret: sortCaret,
        formatter: ViewPhoto,
        headerStyle: {
          width: "90px",
        },
      };
    }
    return {
      dataField: field,
      text: name,
      sort: true,
      sortCaret: sortCaret,
      headerStyle: {
        width: "150px",
      },
    };
  });
  const raw = _rows
    .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
    .filter((row) => round_selected.map((row) => row.value).includes(row.round))
    .filter((row) =>
      product_selected.map((row) => row.value).includes(row.product)
    )
    .filter((row) => agent_selected.map((row) => row.value).includes(row.agent))
    .filter((row) => task_selected.map((row) => row.value).includes(row.task))
    .filter((raw) => {
      const convert = {
        "File (photo)": "file",
        Rate: "rate",
        Comment: "comment",
        "Yes/No": "yesno",
        Quantity: "quantity",
      };
      const task = (Array.isArray(props.tasks) ? props.tasks : []).find(
        (ts) => ts.name === raw.task
      );
      if (!task) {
        return true;
      }
      for (const input of task.input_type) {
        if (raw[convert[input]]) {
          return true;
        }
      }
      return false;
    });
  const options = optionsFactory(raw);
  return (
    <>
      {isOpen && <Lightbox image={isOpen} onClose={() => setImage(null)} />}
      <Card className="p-4 rounded-xl shadow-sm" style={{ minHeight: "600px" }}>
        <Container fluid>
          <Row className="w-100 justify-content-between p-2">
            <div className="col-6 w-100 justify-content-end d-flex ">
              <h1>
                RESULTS
              </h1>
            </div>
            <div className="row">

              <PDFExport
                columns={[ {
                  dataField: "no",
                  text: "No",
                  sort: true,
                  sortCaret: sortCaret,
                  headerStyle: {
                    width: "80px",
                  },
                },...cols].map((col) => col.dataField)}
                data={raw.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
                name="results"
                sign={
                  props.campaign.name +
                  "\n" +
                  moment(props.campaign.start_date).format("MMMM/DD/YY") +
                  "-" +
                  moment(props.campaign.end_date).format("MMMM/DD/YY")
                }
              >
                <button className="btn btn-warning font-weight-bolder mx-2">
                  Export Filters
                </button>
              </PDFExport>
              <PDFExport
                columns={[ {
                  dataField: "no",
                  text: "No",
                  sort: true,
                  sortCaret: sortCaret,
                  headerStyle: {
                    width: "80px",
                  },
                },...cols].map((col) => col.dataField)}
                data={_rows.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
                name="results"
                sign={
                  props.campaign.name +
                  "\n" +
                  moment(props.campaign.start_date).format("MMMM/DD/YY") +
                  "-" +
                  moment(props.campaign.end_date).format("MMMM/DD/YY")
                }
              >
                <button className="btn btn-info font-weight-bolder mx-2">
                  Export Data
                </button>
              </PDFExport>
            </div>
          </Row>
          <br />
          <div className="card p-2 shadow-sm pb-5 px-4">
            <h4 className="text-muted">Filters Criteria</h4>
            <Row>
              <Col>
                <label>Select POS</label>
                <MultiSelect
                  name="pos"
                  options={pos_options}
                  value={pos_selected}
                  onChange={pos_setSelected}
                  labelledBy={"Select POS"}
                />
              </Col>
              <Col>
                <label>Select Rounds</label>
                <MultiSelect
                  name="round"
                  options={round_options}
                  value={round_selected}
                  onChange={round_setSelected}
                  labelledBy={"Select Round"}
                />
              </Col>
              <Col>
                <label>Select Products</label>
                <MultiSelect
                  name="product"
                  options={product_options}
                  value={product_selected}
                  onChange={product_setSelected}
                  labelledBy={"Select Product"}
                />
              </Col>
              <Col>
                <label>Select Users</label>
                <MultiSelect
                  name="user"
                  options={agent_options}
                  value={agent_selected}
                  onChange={agent_setSelected}
                  labelledBy={"Select User"}
                />
              </Col>
              <Col>
                <label>Select Tasks</label>
                <MultiSelect
                  name="task"
                  options={task_options
                    .map(tsk => ({
                      ...tsk,
                      label: tsk.label.toUpperCase()
                    }))
                    .sort((a, b) => {
                      if (a.label > b.label) { return 1 }
                      if (a.label < b.label) { return -1 }
                      return 0
                    })}
                  value={task_selected}
                  onChange={task_setSelected}
                  labelledBy={"Select Taks"}
                />
              </Col>
            </Row>
          </div>
          <br />

          <br />
          {!props.queryng ? (
            <BootstrapTable
              bordered={false}
              wrapperClasses="table-responsive "
              bootstrap4
              hover
              striped
              keyField="no"
              pagination={paginationFactory(options)}
              data={raw.map((doc, i) => ({ no: Number(i) + 1, ...doc })).sort((a, b) => {
                if (a.task > b.task) { return 1 }
                if (a.task < b.task) { return -1 }
                return 0
              })}
              columns={[
                {
                  dataField: "no",
                  text: "No",
                  sort: true,
                  sortCaret: sortCaret,
                  headerStyle: {
                    width: "80px",
                  },
                },
                ...cols,
              ]}
            ></BootstrapTable>
          ) : (
            <div className="mt-2 w-100 d-flex justify-content-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          )}
        </Container>
      </Card>
    </>
  );
}